import gql from 'graphql-tag'
import graphql from 'utils/graphql'
import { EventQuery, EventQueryVariables } from 'generated/graphql'

// Event
export const queryEvent = gql`
    query event($eventId: EventID!) {
        event(id: $eventId) {
            published
            firstPublishedAt
            paid
            isActivationRequested
            name
            slug
            startDate
            endDate
            homeSpace {
                id, name
            }
            goodiebagName
            timezone
            timeFormat
            description
            language
            virtualEventLogo
            backgroundImage
            primaryBrandColor
            secondaryBrandColor
            textEventPreview
            introVideo
            autostartVideo
            textEventPreview
            loginFormAddendum
            terms
            privacyStatement
            helpContent
            helpContentType
            currentUserHasResellerAccess
            maxSpaces
            maxBooths
            maxParticipants
            maxDurationInDays
            openedDaysLeft
            maxDaysWithNetworking
            networkingDaysLeft
            enableChatCarousel
            enableGroupSessions
            amountOfParticipants
            maxOwners
            startWithLoginTab
            userDataIsDeleted 
            hasPublishedNetworking
            showBoothSidebar
            showSpeakerIcon
            showCalendarIcon
            enablePageTranslation

            spaces(first: 499) {
                edges{
                    node{
                        id
                        type
                        slug
                        name
                        published
                        timetableOrder
                    }
                }
                totalCount
            }
            organization {
                id
                subdomain
            }
            maps {
                id
                name
                mapitems {
                    id
                    name
                }
            }
        }
    }
`
export const getEvent = graphql.createQuery<EventQuery, EventQueryVariables>(queryEvent)
